<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
          <a-form-item label="供应商名称">
            <a-input v-model="dataForm.supplier_name" placeholder="供应商名称" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增供应商</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="supplier_id"
          :loading="dataListLoading" :scroll="{ x: 1550 }">
          <template slot="department.department_name" slot-scope="department_name">
            <a-tag>{{ department_name }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="cateHandle(row.supplier_id)">
              项目一级分类
            </a-button>
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.supplier_id)">
              编辑
            </a-button>
            <!-- <a-button
              type="link"
              class="btn-edit"
              @click="deleteHandle(row.supplier_id)"
            >
              删除
            </a-button> -->
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    <cate ref="cate"></cate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
import cate from "../supplierGoods/cate.vue";
const inndata = [];
//子表单列
const innerColumns = [
  {
    title: "分类名称",
    dataIndex: "categorize_name",
    key: "categorize_name",
  },
];
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
    cate,
  },
  data() {
    return {
      inndata,
      innerColumns,
      mixinViewModuleOptions: {
        getDataListURL: "/admin/supplier/page",
        deleteURL: "/admin/supplier/delete",
      },
      expandedRowKeys: [],
      dataForm: {
        supplier_name: "",
      },
      columns: [
        {
          title: "供应商名称",
          dataIndex: "supplier_name",
          width: 300
        },
        {
          title: "供应商公司名称",
          dataIndex: "company_name",
          width: 300
        },
        {
          title: "联系人",
          dataIndex: "contacts",
          width: 120
        },
        {
          title: "联系方式",
          dataIndex: "phone",
          width: 200
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 200
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 250,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    cateHandle(supplier_id) {
      this.$refs.cate.init(supplier_id);
    },
  },
};
</script>